'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StreamSelector = require('./StreamSelector');

var _StreamSelector2 = _interopRequireDefault(_StreamSelector);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _StreamSelectorContainer = require('./StreamSelectorContainer');

var _connectWithContext = require('../../connectWithContext');

var _connectWithContext2 = _interopRequireDefault(_connectWithContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prop-types */
var contextTypes = {
  playerId: _propTypes2.default.string.isRequired
};

/*
 * The null response has to be here, and not in the StreamSelector component.
 *
 *  The reason is that listentoclickoutside binds to the initial render output. With the way our system
 *  works, it always renders null at first. Because of that, listentoclickoutside always thinks you
 *  are clicking outside, even when clicking on the component. Returning null, a layer above the component
 *  fixes that.
 */
exports.default = (0, _connectWithContext2.default)(_StreamSelectorContainer.mapStateToProps, _StreamSelectorContainer.mapDispatchToProps, contextTypes)(function (props) {
  if (!props.streams || props.streams.length < 2) {
    return null;
  }

  return _react2.default.createElement(_StreamSelector2.default, props);
});
module.exports = exports['default'];